<div data-testid="confirm-dialog" class="bg-shui-base-3 rounded-md overflow-hidden min-w-[440px] max-w-[560px]">
    <header class="flex items-center justify-between p-4 pb-2">
        <span class="text-base text-shui-text-strong font-semibold">
            {{ data.title | translate: data.params }}
        </span>
        <sh-icon data-testid="confirm-dialog-button-close" button icon="cancel" size="s" (click)="cancel()"></sh-icon>
    </header>

    <main class="px-4 pb-2 flex flex-col gap-3">
        @if (data.toggle; as toggle) {
            <sh-toggle
                data-testid="confirm-dialog-toggle"
                [label]="toggle.label | translate: data.params"
                [attr.active]="toggle.active ? true : null"
                readonly
            ></sh-toggle>
        }

        <p class="m-0 text-sm text-shui-text-moderate">{{ data.message | translate: data.params }}</p>
    </main>

    <div class="flex justify-between items-center gap-2 p-4">
        <sh-button
            data-testid="confirm-dialog-button-cancel"
            [label]="data.cancelLabel ?? 'common.general.cancel' | translate"
            layout="normal"
            color="secondary"
            size="max-content"
            (click)="cancel()"
        ></sh-button>
        <sh-button
            [attr.data-testid]="data.confirmTestId ?? 'confirm-dialog-button-confirm'"
            [label]="data.confirmLabel ?? 'common.general.confirm' | translate"
            layout="normal"
            color="primary"
            size="max-content"
            (click)="confirm()"
        ></sh-button>
    </div>
</div>
